var _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadarObservatorySvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFB9D2"
    },
    points: "144.834,341.893 110.63,341.893 102.079,470.16 153.385,470.16 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.323,
    y: 470.162,
    style: {
      fill: "#D5DCED"
    },
    width: 136.818,
    height: 34.205
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M129.3,7.632c-27.241,95.347-3.367,202.217,71.723,277.306s181.959,98.964,277.306,71.723 L129.3,7.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF3FB"
    },
    d: "M240.022,142.053c-12.912,60.878-5.44,125.147,22.227,182.083 c3.169,6.521,8.493,11.847,15.015,15.015c62.891,30.561,134.731,36.48,201.062,17.505L258.309,136.641 C252.24,130.571,241.803,133.657,240.022,142.053z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.588,
    y: 42.371,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 666.6477 412.1837)",
    style: {
      fill: "#AFB9D2"
    },
    width: 34.204,
    height: 51.306
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M253.683,327.107l-21.566,21.566c-3.339,3.339-8.754,3.339-12.093,0l-81.969-81.969 c-3.339-3.339-3.339-8.754,0-12.093l21.566-21.566L253.683,327.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5DCED"
    },
    d: "M118.201,306.709l-21.566,21.567c-3.339,3.339-3.339,8.753,0,12.093l48.745,48.745 c3.339,3.339,8.754,3.339,12.093,0l21.566-21.567L118.201,306.709z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.997,351.375l-75.197-75.197l11.651-174.762l34.149-34.149c3.131-3.131,3.131-8.207,0-11.337l-24.186-24.186 c-3.131-3.131-8.207-3.131-11.337,0l-34.149,34.149L210.167,77.545L134.971,2.348c-2.007-2.008-4.927-2.804-7.68-2.092 c-2.749,0.713-4.917,2.827-5.697,5.558c-21.963,76.875-11.034,158.252,27.965,225.574l-17.172,17.172 c-6.459,6.459-6.459,16.97,0,23.43l3.042,3.042l-10.624,26.56l-0.935-0.934c-1.503-1.504-3.542-2.348-5.668-2.348 c-2.126,0-4.165,0.844-5.668,2.348l-21.566,21.567c-6.459,6.459-6.459,16.971,0,23.43l10.973,10.973l-7.339,105.132H59.323 c-4.427,0-8.017,3.589-8.017,8.017v26.188H33.669c-4.427,0-8.017,3.588-8.017,8.017s3.589,8.017,8.017,8.017h188.125 c4.427,0,8.017-3.588,8.017-8.017s-3.589-8.017-8.017-8.017h-17.637v-26.188c0-4.427-3.589-8.017-8.017-8.017H160.85l-4.519-63.264 c2.493-0.769,4.841-2.129,6.81-4.098l21.566-21.566c3.116-3.116,3.129-8.157,0.043-11.291l26.563-10.625l3.042,3.042 c3.229,3.23,7.473,4.845,11.715,4.845s8.485-1.615,11.715-4.845l17.18-17.18c44.261,25.641,94.589,39.161,145.731,39.161 c26.64,0,53.507-3.666,79.836-11.188c2.731-0.78,4.845-2.948,5.558-5.697C486.802,356.306,486.006,353.383,483.997,351.375z M424.745,48.749l12.849,12.849l-24.942,24.942L399.804,73.69L424.745,48.749z M385.371,81.931l19.041,19.041l-10.676,160.139 L225.23,92.609L385.371,81.931z M188.124,495.965H67.34v-18.171h120.785V495.965z M110.675,461.761l6.289-90.11l22.747,22.747 c0.088,0.087,0.183,0.16,0.27,0.245l4.794,67.118H110.675z M151.805,383.06c-0.208,0.208-0.547,0.208-0.757,0l-48.745-48.744 c-0.208-0.208-0.208-0.547,0-0.757l15.898-15.898l3.863,3.863c0.017,0.017,0.034,0.035,0.052,0.052l45.586,45.585L151.805,383.06z M226.448,342.622c-0.208,0.207-0.547,0.207-0.756,0l-6.72-6.72c-0.022-0.024-0.046-0.047-0.069-0.069l-34.196-34.196 c-3.131-3.131-8.207-3.131-11.337,0c-3.131,3.131-3.131,8.207,0,11.337l25.609,25.609l-26.56,10.624l-35.28-35.28l10.625-26.564 c1.558,1.53,3.584,2.297,5.612,2.297c2.051,0,4.103-0.782,5.668-2.348c3.131-3.131,3.131-8.207,0-11.337l-8.537-8.537 c-0.02-0.02-0.041-0.042-0.062-0.062l-6.723-6.723c-0.208-0.208-0.208-0.547,0-0.756l14.49-14.49 c10.687,16.242,23.091,31.532,37.142,45.584c14.052,14.052,29.348,26.449,45.589,37.135L226.448,342.622z M206.691,279.653 c-67.097-67.098-94.491-164.094-73.145-256.055l329.2,329.199C370.786,374.143,273.789,346.75,206.691,279.653z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarObservatorySvgrepoCom);
export default __webpack_public_path__ + "static/media/radar-observatory-svgrepo-com.4fbaf27bc0102a495121c78ae4dce480.svg";
export { ForwardRef as ReactComponent };